import React, { useEffect, useState } from "react";
import { Gauge } from "@mui/x-charts/Gauge";
import { Box, Card, CardContent, CardHeader, Divider, Typography, useTheme } from "@mui/material";

const Guage = ({ value, label, max = 100, body, icon }) => {

  const [valueDisplay, setValue] = useState(0);

  useEffect(() => {
    if (value === null || value === undefined) {
      return;
    }
    else {
      if (value  <= 999) {
        setValue(value);
      }
      else if (value >= 1000){
        let round = (value / 1000).toFixed(1)
        let abbrev = `${round} K`
        setValue(abbrev)
      }
      else if (value > 1000000){
        let round = (value / 1000).toFixed(1)
        let abbrev = `${round} K`
        setValue(abbrev)
      }
      else {
        setValue(value);
      }     
      
    }

  }, [value])

  return (
    <Card sx={{borderRadius: 0}}>
      <CardHeader title={<Typography variant="h6" fontWeight={'bold'}>{body}</Typography>}>
      </CardHeader>
      <Divider/>
      <CardContent>
        <Typography variant="h2">{valueDisplay}</Typography>
      </CardContent>
    </Card>

  );
};

export default Guage;